export default __webpack_public_path__ + "static/media/Brew of Acute Fortitude.46ac0d94.jpg";